import usePostHogFeatureFlagWithPayload from './usePostHogFeatureFlagWithPayload';

const usePostHogFeatureFlag = name => {
  const [value] = usePostHogFeatureFlagWithPayload(name);

  return value;
};

export default usePostHogFeatureFlag;
